import { Card, CardNumberResult, User } from '@varo/graphql-schema-types';
import FetchCardUser from 'services/graphql/queries/FetchCardUser';
import { useQuery } from 'urql';

interface FetchCardAndUserDetailsOutput {
  cardDetails?: Card;
  userDetails?: User;
  cardExpiration?: CardNumberResult;
  fetching: boolean;
  error?: Error;
  refetchBaseQuery: () => void;
}

interface FetchCardAndUserDetailsInput {
  cardId: string;
}

const useFetchCardAndUserDetails = ({
  cardId,
}: FetchCardAndUserDetailsInput): FetchCardAndUserDetailsOutput => {
  const [{ data, fetching, error }, refetchBaseQuery] = useQuery<{
    card: Card;
    user: User;
    cardNumber: CardNumberResult;
  }>({
    query: FetchCardUser,
    variables: { cardId },
    requestPolicy: 'network-only',
  });

  return {
    cardDetails: data?.card,
    userDetails: data?.user,
    cardExpiration: data?.cardNumber,
    fetching,
    error,
    refetchBaseQuery,
  };
};

export default useFetchCardAndUserDetails;
